var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHoriAlignRight24 = function SvgIconHoriAlignRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.35 5.499v13h-1.7v-13h1.7ZM14.5 12.85h-9v-1.7h9v1.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.27 10.947c.603.57.603 1.534 0 2.104l-3.174 3.024-1.173-1.231 2.986-2.845-2.986-2.845 1.173-1.23 3.174 3.023Zm-1.17.87.003-.002-.003.002Z",
    fill: "current"
  })));
};
export default SvgIconHoriAlignRight24;